import { Component, useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import NewReferralLandingPageComponent from 'src/new-referral-landing-page/NewReferralLandingPageComponent.jsx';
import recognitionSettings from 'src/recognitionSettings';
import { Dashboard } from './dashboard';
import { OnDeck } from './_shared/components/on-deck';
import { Redirect } from './_shared/components/redirect';
import { USER_ROLES } from './_shared/constants';
import { RouterContext } from './_shared/contexts';
import MobileTabBar from './_shared/navigation/mobile-tab-bar/MobileTabBar.jsx';
import ShellHandoff from './_shared/components/shell-handoff/ShellHandoffComponent.jsx';
import DefaultSpinner from './_shared/api/DefaultSpinnerComponent.jsx';
import { isMobileShell } from 'src/_shared/shell.js';
import { isLeavingForShellPortal } from 'src/_shared/services/shellHandoff.js';
import { isPhone, onPhoneChange } from 'src/_shared/phone.js';
import ElevatedPermissionsControls from 'src/_shared/components/elevated-permissions/ElevatedPermissionsControls.jsx';
import {
	AuthenticatedRoute,
	ByPassauthenticatedRoute,
	ShareWrapper,
	UnauthenticatedRoute,
} from './_shared/router';
import { Aside } from './_shared/navigation/aside';
import { CustomizableAside } from 'src/customizable-ui/aside/customizableAsideContainer.js';
import { Header } from './_shared/navigation/header';
import allrewards from './allrewards';
import Announcements from 'src/new-announcements/NewAnnouncementsComponent.jsx';
import ApprovalRewards from './approvalRewards';
import ApprovalsBonus from './approvalsBonus';
import MyTeamComponent from './myTeam/MyTeamComponent';
import { BonusCampaigns } from './bonus-campaigns';
import { BonusReportContainer } from './bonus-report';
import { BrowseJobs } from './browseJobs';
import { JobDetailsComponent } from './browseJobs/jobDetail';
import CareerHubComponent from 'src/career-hub/CareerHubComponent.jsx';
import { CareerProfile } from './career-profile';
import { ContactDetails } from './contact-details';
import { CustomPage } from './custom-page';
import { EditEmails } from './edit-emails';
import { EditUserProfile } from './edit-user-profile';
import { EmployeeDetails } from './employee-details';
import { EmployeesDashboard } from './employees-dashboard';
import { GeneralReferralPage } from './general-referral-page';
import { GiftCardStore } from './gift-card-store';
import rewardHome from './home';
import { InternalApplicationContainer } from './internal-applicants';
import { Login, Logout, SAMLMobileLogin, SAMLWebLogin } from './login';
import { ManageJobs } from './manageJobs';
import { JobDetail } from './manageJobs/jobDetail';
import ManageMilestones from './manageMilestones';
import manageRewards from './manageRewards';
import { MessageCenter } from './message-center';
import { MobileRedirect } from './mobile-redirect';
import { MyApplications } from './my-applications';
import { MyBonuses } from './my-bonuses';
import { MyContacts } from './my-contacts';
import { MyProfile } from './my-profile';
import { MyReferrals } from './my-referrals';
import { MyReferralsExtended } from './my-referrals-extended';
import myrewards from './my-rewards';
import {
	NewCompanyUserLandingPage,
	NewExtendedUserLandingPage,
	NewExtendedUserLinkLandingPage,
	NewExternalUserLandingPage,
	NewPartnerUserLandingPage,
	NewSamlUserLandingPage,
	NewUserLandingPage,
} from './new-user-landing-page';
import nominatedRewards from './nominatedRewards';
import selectWinnerContainer from './nominatedRewards/container/SelectWinnerContainer';
import { OpenToNewRole } from './open-to-new-roles';
import { OpenToNewRoleDetails } from './open-to-new-roles-details';
import { Points as OldPoints } from './points';
import Points from 'src/new-points/NewPointsSettingsComponent.jsx';
import { ReferralDetails } from './referral-details';
import { ReferralsDashboardContainer } from './referrals-admin-dashboard';
import { CustomReportRoutes, ReportBuilder } from './reports';
import { ReportHistory } from './reports/report-history/index.js';
import RewardsStoreComponent from 'src/rewardsStore/RewardsStoreComponent';
import { Branding, Settings } from './settings-dashboard';
import { CompanyIntegrations } from './settings-dashboard/integrations/IntegrationsDashboardContainer.jsx';
import { EmployeeDashboardSettings } from './settings-dashboard/employee-dashboard-settings';
import { ReferralTiersSettings } from './settings-dashboard/referral-tiers';
import { SuperUser } from './superUser';
import { AdminIntegrationsPage } from './admin-integrations';
import { WebNotificationsPage } from './web-notifications';
import PragmaticFormBuilder from './new-form-builder/PragmaticFormBuilder.jsx';
import EmployeeManager from './recognitionSettings/employee-manager/EmployeeManagerComponent';
import CandidatePage from './_shared/candidate/pages/CandidatePage.jsx';
import CandidatesListPage from './_shared/candidate/pages/CandidatesListPage.jsx';
import { CustomizableDashboardComponent } from 'src/customizable-ui/dashboard/CustomizableDashboardComponent.jsx';
import CustomPageBuilderComponent from 'src/custom-page-builder/CustomPageBuilderComponent.jsx';
import SnappyHistoryComponent from 'src/snappy-history/SnappyHistoryComponent.jsx';
import CertificateGeneratorComponent from 'src/certificate-generator/CertificateGeneratorComponent.jsx';
const savedAdminControls = localStorage.getItem('showAdminControls');
class AppRouter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sidebarOpen: true,
			phone: isPhone(),
			resultData: '',
			disableSite: false,
			// On a phone the super admin controls dock under the header's ERIN
			// icon and cover the page, so they start hidden and open on tap.
			showAdminControls: isPhone()
				? false
				: savedAdminControls
					? savedAdminControls === 'true'
					: true,
			showNav:
				window.location.pathname.includes('newreferral') ||
				window.location.pathname.includes('newinternalreferral') ||
				window.location.pathname.includes('logout'),
		};
	}

	hamburgerToggleClickHandler = () => {
		this.setState((prevState) => {
			return { sidebarOpen: !prevState.sidebarOpen };
		});
	};

	toggleAdminControls = () => {
		this.setState((prevState) => {
			const newShowAdminControls = !prevState.showAdminControls;
			localStorage.setItem(
				'showAdminControls',
				newShowAdminControls.toString()
			);
			return { showAdminControls: newShowAdminControls };
		});
	};

	componentDidMount() {
		this.stopPhoneWatch = onPhoneChange((phone) => this.setState({ phone }));
	}

	componentWillUnmount() {
		this.stopPhoneWatch?.();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps?.currentUser?.id !== this.props?.currentUser?.id &&
			this.state.showAdminControls
		) {
			this.toggleAdminControls();
		}
		const showNav =
			window.location.pathname.includes('newreferral') ||
			window.location.pathname.includes('newinternalreferral') ||
			window.location.pathname.includes('logout');
		if (showNav !== this.state.showNav) this.setState({ showNav });
		// On a phone the side menu is an overlay: close it once a menu link
		// has navigated. (sidebarOpen is true when the menu is hidden on phone
		// widths; see .sidebar-close.)
		if (
			this.state.phone &&
			!this.state.sidebarOpen &&
			prevProps.location?.pathname !== this.props.location?.pathname
		) {
			this.setState({ sidebarOpen: true });
		}
	}

	render() {
		const { showNav } = this.state;
		const host = window.location.hostname;

		const enableByHost =
			host === 'erin-app-demo.netlify.app' || host === 'localhost';
		return (
			<RouterContext.Consumer>
				{({ auth, currentUser, handleSignOut, primaryPlatform }) => {
					const recognitionEnabled =
						currentUser?.featureFlags?.includes('recognitionPlatform') ||
						enableByHost ||
						currentUser?.enableRecognition ||
						currentUser?.company?.enableRecognition;

					const newPointsEarlyPreview = currentUser?.featureFlags?.includes(
						'newPointsEarlyPreview'
					);

					const recHubDisabled =
						currentUser?.company?.recognitionSettings?.disableRecHub;

					const AsideComponent = currentUser?.company?.enableCustomNav
						? CustomizableAside
						: Aside;

					const DashboardComponent =
						currentUser?.company?.enableCustomDashboard &&
						((currentUser?.role !== 'admin' &&
							currentUser?.role !== 'superAdmin') ||
							currentUser.displayAs !== 'admin')
							? CustomizableDashboardComponent
							: Dashboard;

					const DashboardSettingsComponent = currentUser?.company
						?.enableCustomDashboard
						? CustomizableDashboardComponent
						: EmployeeDashboardSettings;

					// ERIN-8561: a shell user whose company has moved to the eAI
					// portal is on their way out (ShellHandoff sends them to the
					// sign-out page, which hands the shell the portal). Show the
					// sign-out spinner now rather than paint the dashboard for a
					// frame first.
					if (
						isLeavingForShellPortal({
							auth,
							currentUser,
							pathname: this.props.location?.pathname,
							inShell: isMobileShell(),
						})
					) {
						return (
							<>
								<ShellHandoff auth={auth} currentUser={currentUser} />
								<DefaultSpinner />
							</>
						);
					}

					return (
						<div className={auth ? 'wrapper' : 'auth-wrapper'}>
							<ShellHandoff auth={auth} currentUser={currentUser} />
							{auth && !showNav && (
								<>
									<AsideComponent
										show={this.state.sidebarOpen}
										user={currentUser}
										hamburgerClickHandler={this.hamburgerToggleClickHandler}
									/>
									<ElevatedPermissionsControls
										history={this.props.history}
										toggleAdminControls={this.toggleAdminControls}
										showAdminControls={this.state.showAdminControls}
									/>
								</>
							)}
							<div
								style={
									!showNav
										? {
												height: '100vh',
												overflow: 'scroll',
											}
										: {}
								}
								className="container-fluid"
							>
								{auth && !showNav && (
									<Header
										hamburgerClickHandler={this.hamburgerToggleClickHandler}
										user={currentUser}
										toggleAdminControls={this.toggleAdminControls}
										showAdminControls={this.state.showAdminControls}
									/>
								)}
								{auth && !showNav && this.state.phone && (
									<MobileTabBar
										currentUser={currentUser}
										onMore={this.hamburgerToggleClickHandler}
									/>
								)}
								{auth &&
									!showNav &&
									this.state.phone &&
									!this.state.sidebarOpen && (
										<div
											className="sidebar-scrim"
											aria-hidden="true"
											onClick={this.hamburgerToggleClickHandler}
										/>
									)}
								<div className="row">
									<div className="col-12">
										<div className="content-area">
											<Switch>
												<Route
													exact
													path="/"
													render={(props) => (
														<Home
															{...props}
															currentUser={currentUser}
															primaryPlatform={primaryPlatform}
															auth={auth}
														/>
													)}
												/>
												<UnauthenticatedRoute path="/login" component={Login} />
												<UnauthenticatedRoute
													path="/saml-auth/login"
													component={SAMLWebLogin}
												/>
												<UnauthenticatedRoute
													path="/claim"
													component={Login}
													routeData={{
														openClaimYourAccount: true,
													}}
												/>
												<UnauthenticatedRoute
													path="/saml/login"
													component={SAMLMobileLogin}
												/>
												<UnauthenticatedRoute
													path="/newuser/:id"
													component={NewUserLandingPage}
												/>
												<UnauthenticatedRoute
													path="/signup/:id"
													component={NewPartnerUserLandingPage}
												/>
												<UnauthenticatedRoute
													path="/new-user/:id"
													component={NewExtendedUserLandingPage}
												/>
												<UnauthenticatedRoute
													path="/external-user"
													component={NewExternalUserLandingPage}
												/>
												<UnauthenticatedRoute
													path="/new-user-sign-up/:id"
													component={NewExtendedUserLinkLandingPage}
												/>
												<UnauthenticatedRoute
													path="/new-user-signup/:id"
													component={NewCompanyUserLandingPage}
												/>
												<ByPassauthenticatedRoute
													exact
													path="/newreferral/:referralId"
													component={NewReferralLandingPageComponent}
													pageType="standard"
												/>
												<UnauthenticatedRoute
													exact
													path="/mobile-redirect"
													component={MobileRedirect}
												/>
												<Route exact path="/share" component={ShareWrapper} />
												<ByPassauthenticatedRoute
													exact
													path="/newreferral/:referredById/:jobId/:langCode"
													component={NewReferralLandingPageComponent}
													pageType="public"
												/>
												<ByPassauthenticatedRoute
													exact
													path="/newreferral/:webNotificationId/:langCode"
													component={NewReferralLandingPageComponent}
													pageType="gdpr"
												/>
												<ByPassauthenticatedRoute
													exact
													path="/newinternalreferral/:referredById/:jobId/:referredUserId"
													component={NewReferralLandingPageComponent}
													pageType="internal"
												/>
												<UnauthenticatedRoute
													exact
													path="/generalreferral/:referredBy/:id"
													component={GeneralReferralPage}
												/>
												<Route
													exact
													path="/google/login"
													render={(props) => <Redirect google nav={props} />}
												/>
												<Route
													exact
													path="/:companycode/login"
													render={(props) => <Redirect saml nav={props} />}
												/>
												<Route
													path="/newsamluser/:id"
													render={(props) => (
														<NewSamlUserLandingPage {...props} />
													)}
												/>
												<Route
													path="/logout"
													render={(props) => (
														<Logout {...props} handleSignOut={handleSignOut} />
													)}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/giftcardstore"
													component={GiftCardStore}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/rewards-store"
													component={RewardsStoreComponent}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/myapplications"
													component={MyApplications}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/browsejobs"
													component={BrowseJobs}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/browsejobs/new"
													component={BrowseJobs}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/browsejobs/:id"
													component={JobDetailsComponent}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/dashboard"
													component={DashboardComponent}
													sidebarOpen={this.state.sidebarOpen}
												/>
												<AuthenticatedRoute
													exact
													roles={[USER_ROLES.EXTENDED_USER]}
													path="/my-referrals"
													component={MyReferralsExtended}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/career"
													component={CareerProfile}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/internal"
													component={CareerHubComponent}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/employees"
													component={EmployeesDashboard}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/employees/form"
													component={EmployeesDashboard}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/referrals"
													component={ReferralsDashboardContainer}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/referrals/:id"
													component={ReferralDetails}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/employees/:id"
													component={EmployeeDetails}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/jobs"
													component={ManageJobs}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/jobs/:id"
													component={JobDetail}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/editprofile/:id"
													component={EditUserProfile}
												/>
												<AuthenticatedRoute
													path="/myreferrals"
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													component={MyReferrals}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/notifications"
													component={WebNotificationsPage}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/candidates"
													component={CandidatesListPage}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/candidates/:id"
													component={CandidatePage}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/mycontacts"
													component={MyContacts}
													{...this.props}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/mycontacts/:id"
													component={ContactDetails}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/mycontacts/add/form"
													component={MyContacts}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/admin-console"
													component={SuperUser}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/admin-integrations"
													component={AdminIntegrationsPage}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/settings"
													component={Settings}
												/>
												<AuthenticatedRoute
													exact
													roles={[USER_ROLES.SUPER_ADMIN]}
													path="/integrations"
													component={CompanyIntegrations}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
													]}
													path="/deck"
													component={OnDeck}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
													]}
													path="/bonuses"
													component={BonusReportContainer}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/builder"
													component={ReferralTiersSettings}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.EXTENDED_USER,
													]}
													path="/myprofile"
													component={MyProfile}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/messagecenter"
													component={MessageCenter}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/bonus-campaigns"
													component={BonusCampaigns}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/points"
													component={newPointsEarlyPreview ? Points : OldPoints}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/form-builder"
													component={PragmaticFormBuilder}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/job-notification-email"
													component={EditEmails}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/branding"
													component={Branding}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/employee-dashboard-settings"
													component={DashboardSettingsComponent}
													sidebarOpen={this.state.sidebarOpen}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/report-builder"
													component={ReportBuilder}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/report-history"
													component={ReportHistory}
												/>
												<AuthenticatedRoute
													path="/mybonuses"
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
													]}
													component={MyBonuses}
												/>
												<AuthenticatedRoute
													path="/custompage/:customPageId"
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
													]}
													component={CustomPage}
												/>
												<AuthenticatedRoute
													path="/announcements"
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
													]}
													component={Announcements}
												/>
												<AuthenticatedRoute
													path="/internal-applicants"
													roles={[
														USER_ROLES.EMPLOYEE,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
													]}
													component={InternalApplicationContainer}
												/>
												<AuthenticatedRoute
													path="/open"
													roles={[
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.ADMIN,
													]}
													component={OpenToNewRole}
												/>
												<AuthenticatedRoute
													exact
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.MANAGER,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													path="/openDetails/:id"
													component={OpenToNewRoleDetails}
												/>
												<AuthenticatedRoute
													path="/custom-page-builder"
													roles={[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]}
													component={CustomPageBuilderComponent}
												/>
												<AuthenticatedRoute
													path="/manage-recognitions"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={manageRewards}
												/>
												<AuthenticatedRoute
													path="/manage-milestones"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={ManageMilestones}
												/>
												<AuthenticatedRoute
													path="/employee-manager"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={EmployeeManager}
												/>
												<AuthenticatedRoute
													path="/recognition-approvals"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={ApprovalRewards}
													{...this.props}
												/>
												<AuthenticatedRoute
													path="/my-team"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.MANAGER,
																	USER_ROLES.ADMIN,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={MyTeamComponent}
													{...this.props}
												/>
												<AuthenticatedRoute
													path="/nominations"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={nominatedRewards}
												/>
												<AuthenticatedRoute
													path="/recognition-settings"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={recognitionSettings}
												/>
												<AuthenticatedRoute
													path="/snappy-history"
													roles={
														recognitionEnabled
															? [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]
															: []
													}
													component={SnappyHistoryComponent}
												/>
												<AuthenticatedRoute
													path="/select-winner/:id"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.ADMIN,
																	USER_ROLES.MANAGER,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={selectWinnerContainer}
												/>
												<AuthenticatedRoute
													path="/recognition-hub"
													roles={
														recognitionEnabled && !recHubDisabled
															? [
																	USER_ROLES.EMPLOYEE,
																	USER_ROLES.ADMIN,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																	USER_ROLES.MANAGER,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={rewardHome}
												/>
												<AuthenticatedRoute
													path="/my-recognitions"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.EMPLOYEE,
																	USER_ROLES.ADMIN,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																	USER_ROLES.MANAGER,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={myrewards}
												/>
												<AuthenticatedRoute
													path="/recognitions"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.EMPLOYEE,
																	USER_ROLES.ADMIN,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																	USER_ROLES.MANAGER,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={allrewards}
												/>
												<AuthenticatedRoute
													path="/approvals-bonus"
													roles={
														recognitionEnabled
															? [
																	USER_ROLES.EMPLOYEE,
																	USER_ROLES.ADMIN,
																	USER_ROLES.SUPER_ADMIN,
																	USER_ROLES.SUPPORT_ADMIN,
																	USER_ROLES.MANAGER,
																]
															: [USER_ROLES.SUPER_ADMIN]
													}
													component={ApprovalsBonus}
													{...this.props}
												/>
												<AuthenticatedRoute
													roles={[
														USER_ROLES.ADMIN,
														USER_ROLES.SUPER_ADMIN,
														USER_ROLES.SUPPORT_ADMIN,
													]}
													exact
													path="/certificate-generator"
													component={CertificateGeneratorComponent}
												/>
												{currentUser?.company?.metabaseReports && (
													<CustomReportRoutes />
												)}
												{/* Catch all route for any unmatched
						requests and navigates back to "Home" Component */}
												<Route
													render={(props) => (
														<Home
															{...props}
															currentUser={currentUser}
															primaryPlatform={primaryPlatform}
															auth={auth}
														/>
													)}
												/>
											</Switch>
										</div>
									</div>
								</div>
							</div>
						</div>
					);
				}}
			</RouterContext.Consumer>
		);
	}
}

function Home(props) {
	useEffect(() => {
		if (props.auth && props?.primaryPlatform === 'recognition') {
			if (
				props.currentUser?.role === USER_ROLES.ADMIN ||
				props.currentUser?.role === USER_ROLES.SUPER_ADMIN
			) {
				props.history.push('/recognition-approvals');
			} else {
				props.history.push('/recognition-hub');
			}
		} else if (props.auth) {
			if (props.currentUser?.isScopedUser) {
				let scopedPolicy = props.currentUser?.scopedPolicy || {};
				if (typeof scopedPolicy === 'string') {
					try {
						scopedPolicy = JSON.parse(scopedPolicy);
					} catch (e) {
						scopedPolicy = {};
						console.error(e);
					}
				}
				const allowedPaths = scopedPolicy?.paths || [];

				// Find the first allowed path that's not a deny pattern
				const firstAllowedPath = allowedPaths.find(
					(path) => !path.startsWith('!') && !path.endsWith('/*')
				);

				if (firstAllowedPath) {
					props.history.push(firstAllowedPath);
				} else {
					// If no specific path found, try dashboard
					props.history.push('/dashboard');
				}
			} else {
				props.history.push('/dashboard');
			}
		} else {
			props.history.push('/login');
		}
	}, []);

	return null;
}

export default withRouter(AppRouter);
